import {memo, useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

import useActiveSectionScrollSpy from '../../hooks/useActiveSectionScrollSpy.js'
import useAdBackUrl from '../../hooks/useAdBackUrl.js'
import useStickyState from '../../hooks/useStickyState.js'
import AdActions from './AdActions.js'
import AdInfoContent from './AdInfoContent.js'
import BackButton from './BackButton.js'
import {BASE_CLASS} from './config.js'
import SectionNav from './SectionNav.js'

const SecondaryBar = ({
  ad,
  adInfo = {},
  breadcrumb,
  contractId,
  extendedTrackingData,
  hasDiscardButton,
  isFavorite,
  isFavoriteLeadEnabled,
  onFavoriteLeadConfirm,
  visibleSectionIds
}) => {
  const {domain} = useContext(Context)
  const isMobile = domain.get('config').get('isMobile')
  const isTabletOrHigher = useMediaQuery(useMediaQueryBreakpoints.sm, {defaultMatches: !isMobile})

  const {sentinelRef, isSticky} = useStickyState()
  const activeSectionId = useActiveSectionScrollSpy(visibleSectionIds)
  const hrefBack = useAdBackUrl(ad.id)

  return (
    <>
      <div ref={sentinelRef} className={`${BASE_CLASS}-sentinel`} />
      <div
        className={cx(BASE_CLASS, {
          [`${BASE_CLASS}--sticky`]: isSticky
        })}
      >
        <div className={`${BASE_CLASS}-inner`}>
          <BackButton breadcrumb={breadcrumb} hrefBack={hrefBack} />

          {isTabletOrHigher && (
            <div className={`${BASE_CLASS}-content`}>
              {isSticky ? (
                <SectionNav activeSectionId={activeSectionId} visibleSectionIds={visibleSectionIds} />
              ) : (
                <AdInfoContent price={adInfo.price} title={adInfo.title} />
              )}
            </div>
          )}

          <AdActions
            ad={ad}
            breadcrumb={breadcrumb}
            contractId={contractId}
            extendedTrackingData={extendedTrackingData}
            hasDiscardButton={hasDiscardButton}
            hrefBack={hrefBack}
            isFavorite={isFavorite}
            isFavoriteLeadEnabled={isFavoriteLeadEnabled}
            onFavoriteLeadConfirm={onFavoriteLeadConfirm}
          />
        </div>
      </div>
    </>
  )
}

SecondaryBar.displayName = 'SecondaryBar'
SecondaryBar.propTypes = {
  ad: PropTypes.object.isRequired,
  adInfo: PropTypes.shape({
    price: PropTypes.string,
    title: PropTypes.string
  }),
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({url: PropTypes.string})),
  contractId: PropTypes.string,
  extendedTrackingData: PropTypes.object,
  hasDiscardButton: PropTypes.bool,
  isFavorite: PropTypes.bool,
  isFavoriteLeadEnabled: PropTypes.bool,
  onFavoriteLeadConfirm: PropTypes.func,
  visibleSectionIds: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default memo(SecondaryBar)
